module.exports = __webpack_public_path__ + "img/zm.4336fc28.svg";